import { API } from 'aws-amplify';

const getMezzanineApiName = () => {
  const env = process.env.REACT_APP_API_ENVIRONMENT || "Gamma";
  return env === "Prod" ? "MezzanineProd" : "MezzanineGamma";
};

const apiPost = async (path, body = {}) => {
  const apiName = getMezzanineApiName();
  
  const options = {
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  return API.post(apiName, path, options);
};

export const getChannels = () => apiPost("/channels/list-channels");

export const getOutputs = () => apiPost("/channels/list-outputs");

export const getDeployments = () => apiPost("/deployments/get");

export const getChannelStatus = (channelId) =>
  apiPost("/channels/get-channel-status", { channel_id: channelId });

export const getAlarmHistory = (channelId) =>
  apiPost("/channels/get-alarm-history", { channel_id: channelId });

// Returns a single still from the channel's SDI input as an inline base64 PNG,
// along with the slot and SDI it was captured from. Note the path is singular.
export const getChannelThumbnail = (channelId) =>
  apiPost("/channels/get-thumbnail", { channel_id: channelId });

export const getProgramGroups = () => apiPost("/program-groups/get");

export const getProfiles = () => apiPost("/profiles/get");

export const createProgramGroup = (data) => apiPost("/program-groups/create", data);

export const importProfileFromDevice = (data) => apiPost("/profiles/import", data);

export const getDataCenters = () => apiPost("/data-centers/get");

export const getDevices = () => apiPost("/devices/get");

export const getTxChains = () => apiPost("/tx-chains/get");

export const createChannel = (data) => apiPost("/channels/create", data);

export const createEvisDeployment = (data) => apiPost("/deployments/evis/create", data);

export const executeStateMachine = (stateMachineName, input) => 
  apiPost("/state-machines/execute", { state_machine_name: stateMachineName, input });

export const getStateMachineStatus = (executionArn) => 
  apiPost("/state-machines/get-status", { execution_arn: executionArn });

export const updateChannel = (channelId, groupName) => 
  apiPost("/channels/update", { channel_id: channelId, group_name: groupName });

export default {
  getChannels,
  getOutputs,
  getProgramGroups,
  getDataCenters,
  getDevices,
  getDeployments,
  getChannelStatus,
  getAlarmHistory,
  createChannel,
  createEvisDeployment,
  executeStateMachine,
  getStateMachineStatus,
  updateChannel,
};
